import { render, staticRenderFns } from "./GridRowParagraph.vue?vue&type=template&id=bcd569e0"
import script from "./GridRowParagraph.vue?vue&type=script&lang=ts"
export * from "./GridRowParagraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports